import { useChatMessageSchedulingContext } from 'features/chat/context/chatMessageScheduling';
import { useChatMessagesContext } from 'features/chat/context/chatMessages';

import { UnuploadedAttachment } from '../config/types/Attachment';
import { useClearChatForm } from './useClearChatForm';

export const useChatFormAttachmentSubmit = () => {
  const clearChatForm = useClearChatForm();
  const { sendMessageWithAttachments, parentMessage, editedMessage } =
    useChatMessagesContext();
  const { createScheduledAttachmentMessage } =
    useChatMessageSchedulingContext();

  const onFormSubmitWithAttachment = (
    text: string,
    attachments: UnuploadedAttachment[],
    scheduledFor?: string
  ) => {
    if (scheduledFor) {
      createScheduledAttachmentMessage({
        text,
        attachments,
        scheduledFor,
        parentMessage,
      });
    } else {
      sendMessageWithAttachments({ text, attachments, editedMessage });
    }
    clearChatForm();
  };

  return {
    onFormSubmitWithAttachment,
  };
};
